import React from 'react'
import { Box, Flex, Text, HStack } from '@chakra-ui/react'

import OutlineBox from '~components/shared/wrappers/outline-box'

interface Props {
    title: string
    hintText?: string[]
}

export default function PreviewBox({ title, hintText }: Props) {
    return (
        <OutlineBox w="full" shadow="none">
            <Flex w="full" justifyContent="space-between" alignItems="center">
                <HStack spacing={4}>
                    <Box>
                        <Text fontWeight="semibold" mb={-0.5}>
                            {title}
                        </Text>
                        {hintText &&
                            hintText.map((text, idx) => (
                                <Text key={idx} fontSize="xs" color="gray.500">
                                    {text}
                                </Text>
                            ))}
                    </Box>
                </HStack>
            </Flex>
        </OutlineBox>
    )
}
